import React, { createContext, useContext, useEffect, useMemo, useState } from "react";
import api from "@/api";
import { DEFAULT_BRANDING, normalizeBranding } from "@/lib/branding";

const BrandingContext = createContext({
  branding: normalizeBranding(DEFAULT_BRANDING),
  refreshBranding: async () => {},
  setBranding: () => {},
});

export function BrandingProvider({ children }) {
  const [branding, setBrandingState] = useState(() =>
    normalizeBranding(DEFAULT_BRANDING)
  );

  const refreshBranding = async () => {
    try {
      const res = await api.get("/brand-settings");
      setBrandingState(normalizeBranding(res.data));
    } catch {
      setBrandingState(normalizeBranding(DEFAULT_BRANDING));
    }
  };

  useEffect(() => {
    refreshBranding();
  }, []);

  useEffect(() => {
    document.title = "JewelFlow | Crafted for Efficiency.";
  }, [branding.brand_name, branding.system_name]);

  const value = useMemo(
    () => ({
      branding,
      refreshBranding,
      setBranding: (nextBranding) =>
        setBrandingState(normalizeBranding(nextBranding)),
    }),
    [branding]
  );

  return (
    <BrandingContext.Provider value={value}>
      {children}
    </BrandingContext.Provider>
  );
}

export function useBranding() {
  return useContext(BrandingContext);
}
